export default "__VITE_ASSET__E9WrGN6m__"